import { getHourOptions } from '../utils/recurrence';
import { isInTimeRange } from '../utils/time';

export const types = {
  SET_MINUTES: 'SET_MINUTES',
  SET_HOURS: 'SET_HOURS',
  SET_MERIDIEM: 'SET_MERIDIEM'
};

export default function reducer(state, action) {
  switch (action.type) {
    case types.SET_MINUTES: {
      return { ...state, minutes: action.response };
    }
    case types.SET_HOURS: {
      return { ...state, hours: action.response };
    }
    case types.SET_MERIDIEM: {
      const { meridiem, minTime, maxTime } = action.response;
      const hourOptions = getHourOptions(meridiem, minTime, maxTime);
      let { hours, minutes } = state;

      // avoid to use time which out of the limits
      if ((minTime || maxTime) && !hourOptions.find(({ value }) => value === Number(hours))) {
        hours = hourOptions[0].value;
      }
      if (!isInTimeRange(`${hours}:${minutes} ${meridiem}`, minTime, maxTime)) {
        minutes = 0;
      }

      return {
        ...state, meridiem, hours, minutes
      };
    }
    default: {
      return state;
    }
  }
}
